import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = ({ theme }) => ({
    marginBottom: '1.25rem',
    backgroundColor: theme.colors.backgroundsSecondary,
    borderRadius: '0.25rem',
});

export const titleContainer: TRuleWithTheme = ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    columnGap: '0.5rem',

    paddingTop: '0.5rem',
    minHeight: '2.5rem',
});

export const divider: TRuleWithTheme = ({ theme }) => ({
    marginTop: '1rem',
    marginBottom: '1.25rem',

    borderTop: 'none',
    borderLeft: 'none',
    borderRight: 'none',
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.colors.foregroundsSeparator,
});

export const info: TRuleWithTheme = ({ theme }) => ({
    marginBottom: '0.25rem',

    ...theme.typography.ParagraphSmallMedium,

    color: theme.colors.foregroundsTertiary,

    ':last-of-type': {
        marginBottom: '1.25rem',
    },
});

export const changeSubscriptionWarning: TRuleWithTheme = ({ theme }) => ({
    marginTop: '1rem',
    fontWeight: 400,
});
